import useFeatureFlagValue from '@/components/analytics/hooks/useFeatureFlagValue';

/**
 * PD-7442: hides reCAPTCHA on web forms when this flag is true.
 * False keeps the widget. The fallback is false, so a missing flag still shows reCAPTCHA.
 *
 * @see https://firsttable.atlassian.net/browse/PD-7442
 * @see https://app.growthbook.io/features/pd-7442-remove-recaptcha-on-web-forms
 * @see https://app.growthbook.io/experiment/exp_19g6emvim06nm
 */
export const PD7442_RECAPTCHA_FLAG = 'pd-7442-remove-recaptcha-on-web-forms';

export default function useRecaptchaEnabled(): boolean {
  return useFeatureFlagValue(PD7442_RECAPTCHA_FLAG, false) !== true;
}
